import React from 'react'

export default function PrepareForPrint(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="#100074"
          fill-opacity=".1"
          d="M30.3 8.8V32c0 1.8-1.5 3.2-3.2 3.2H5c-1.8 0-3.2-1.5-3.2-3.2V4C1.8 2.2 3.2.7 5 .7h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6.9.6 1.5Z"
          opacity=".1"
        />
        <path
          fill="#100074"
          d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"
        />
        <path
          fill="#100074"
          fill-opacity=".8"
          d="M23.146 6.5c.597 0 1.148.309 1.332.912l.022.071V13h-1V7.66c-.043-.081-.138-.16-.354-.16H8.896c-.21.03-.336.08-.395.12V13h-1V7.559c0-.36.215-.62.453-.777.232-.151.526-.238.835-.278L8.82 6.5h14.326Z"
        />
        <path
          fill="#100074"
          fill-opacity=".8"
          d="M26.2 21.2v-7.1c0-.186-.06-.302-.129-.371-.068-.069-.184-.129-.37-.129H6.5c-.186 0-.302.06-.371.129S6 13.914 6 14.1v7c0 .186.06.303.129.371.069.069.185.13.371.13H10v1H6.5c-.414 0-.797-.141-1.078-.423C5.14 21.897 5 21.514 5 21.1v-7c0-.413.14-.797.422-1.078.281-.281.664-.422 1.078-.422h19.2c.414 0 .797.14 1.078.422.282.281.422.665.422 1.078v7.1c0 .776-.624 1.4-1.4 1.4h-3.3v-1h3.3c.224 0 .4-.176.4-.4Z"
        />
        <path
          fill="#100074"
          fill-opacity=".8"
          d="M22.1 19.5H10.5v6.4c0 .324.276.6.6.6h10.3c.166 0 .35-.072.493-.198a.56.56 0 0 0 .207-.402v-6.4Zm1 6.4c0 .472-.235.875-.542 1.149a1.767 1.767 0 0 1-1.158.451H11.1a1.61 1.61 0 0 1-1.6-1.6v-7.4h13.6v7.4Z"
        />
        <path
          fill="#100074"
          fill-opacity=".8"
          d="m17.8 24 .008.5-6.8.1-.016-1 6.801-.1.007.5Zm3.505-2.5-10.3.1-.01-1 10.3-.1.01 1Z"
        />
        <path
          fill="#100074"
          fill-opacity=".1"
          d="M7.2 14.5h17.7v1.1H7.2v-1.1Z"
        />
      </svg>
    </div>
  )
}
